import { sha256 } from "@noble/hashes/sha2.js";
const getBufferSha256 = async buffer => {
  const digest = globalThis.crypto?.subtle ? new Uint8Array(await globalThis.crypto.subtle.digest("SHA-256", buffer)) : sha256(new Uint8Array(buffer));
  return Array.from(digest, byte => byte.toString(16).padStart(2, "0")).join("");
};
export { getBufferSha256 };